/* eslint-disable lingui/no-unlocalized-strings */
import { openai } from "./client";

const SYSTEM_PROMPT = `你是一位专业的简历优化顾问。你的任务是根据发现的问题对简历内容进行优化。

【输出格式规范】
<ul>
<li>段落使用 <p> 标签</li>
<li>换行使用 <br> 标签</li>
<li>列表使用 <ul> 和 <li> 标签</li>
<li>重点内容使用 <strong> 标签</li>



【优化原则】
1. 针对每个问题进行定向优化
2. 保持原文的核心信息
3. 确保优化后的内容更专业、更有说服力
4. 使用具体的数据和成果支撑
5. 突出个人贡献和价值

【注意事项】
- 使用 html 标签，不要使用 markdown 标签
- 保持专业性和可信度
- 确保数据和成果可量化
- 使用行业标准术语
- 优化后的内容应当解决原有问题`;

// 处理单个问题的优化
const SINGLE_ISSUE_PROMPT = `请针对以下问题优化简历内容：
问题：{issue}

原文：{content}

请直接返回优化后的文本，不要包含任何解释性文字。`;

// 处理所有问题的优化
const ALL_ISSUES_PROMPT = `请针对以下所有问题优化简历内容：
问题列表：
{issues}

原文：{content}

请直接返回优化后的文本，不要包含任何解释性文字。`;

type SmartCheckIssue = {
  id: string;
  content: string;
  // 其他问题相关的属性
};

// 优化单个问题
export const improveSingleIssue = async (text: string, issue: SmartCheckIssue) => {
  console.log("调用 improveSingleIssue:", {
    textLength: text.length,
    issue,
  });

  const result = await openai().chat.completions.create({
    messages: [
      { role: "system", content: SYSTEM_PROMPT },
      {
        role: "user",
        content: SINGLE_ISSUE_PROMPT.replace("{issue}", issue.content).replace("{content}", text),
      },
    ],
    model: "glm-4-flash",
    max_tokens: 2048,
    temperature: 0,
    n: 1,
  });

  console.log("improveSingleIssue API 响应:", {
    success: result.choices.length > 0,
    resultLength: result.choices[0]?.message?.content?.length,
  });

  if (result.choices.length === 0) {
    throw new Error(`OpenAI 没有返回任何内容。`);
  }

  return result.choices[0].message.content ?? text;
};

// 优化所有问题
export const improveAllIssues = async (text: string, issues: SmartCheckIssue[]) => {
  console.log("调用 improveAllIssues:", {
    textLength: text.length,
    issuesCount: issues.length,
    issues,
  });

  const issuesText = issues.map((issue, index) => `${index + 1}. ${issue.content}`).join("\n");

  const result = await openai().chat.completions.create({
    messages: [
      { role: "system", content: SYSTEM_PROMPT },
      {
        role: "user",
        content: ALL_ISSUES_PROMPT.replace("{issues}", issuesText).replace("{content}", text),
      },
    ],
    model: "glm-4-flash",
    max_tokens: 2048,
    temperature: 0,
    n: 1,
  });

  console.log("improveAllIssues API 响应:", {
    success: result.choices.length > 0,
    resultLength: result.choices[0]?.message?.content?.length,
  });

  if (result.choices.length === 0) {
    throw new Error(`OpenAI 没有返回任何内容。`);
  }

  return result.choices[0].message.content ?? text;
};
